// Stat-card pattern: when every H4 row in a `.template__rich` block is a
// label/value pair — `<h4>Label</h4><p><strong>Value</strong></p>` — render
// the group as a value grid instead of standard left/right rows. See
// skills/template-builder-skill-v2.md ("Key-Value Stat Rows — Card Pattern")
// for the authoring convention this depends on.

const VALUE_VARIANT_CLASS = 'w-variant-7128fecb-3893-cd81-cc62-2a7143afba91';

const moveChildren = (target, source) => {
  Array.from(source.childNodes).forEach((node) => target.appendChild(node));
};

export const isStatCardSection = (section) => {
  if (!section.heading || section.body.length !== 1) {
    return false;
  }

  const [body] = section.body;

  if (!body.matches('p') || body.children.length !== 1) {
    return false;
  }

  const [strong] = body.children;

  return strong.matches('strong') && body.textContent.trim() === strong.textContent.trim();
};

const createValueItem = (section) => {
  const [body] = section.body;
  const [strong] = body.children;

  const item = document.createElement('div');
  item.className = 'tab__values-item';

  const variantWrap = document.createElement('div');
  variantWrap.setAttribute('data-wf--value--variant', 'value-2');

  const valueColumn = document.createElement('div');
  valueColumn.className = `content__copy--value ${VALUE_VARIANT_CLASS}`;
  moveChildren(valueColumn, strong);

  const labelColumn = document.createElement('div');
  labelColumn.className = 'content__copy--b-5 copy__weight--bold';
  moveChildren(labelColumn, section.heading);

  variantWrap.appendChild(valueColumn);
  item.appendChild(variantWrap);
  item.appendChild(labelColumn);

  return item;
};

export const buildStatValueGrid = (sections) => {
  const grid = document.createElement('div');
  grid.className = 'tab__values--grid';

  sections.forEach((section) => grid.appendChild(createValueItem(section)));

  return grid;
};

export const buildStatCardGrid = (sections, title) => {
  const card = document.createElement('div');
  card.className = 'content__table-card';

  if (title) {
    card.appendChild(title);
  }

  const grid = buildStatValueGrid(sections);

  card.appendChild(grid);
  return card;
};
